const UserPlus = ({ size=24, color="#090909", ...props }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
    >
        <path d="M2 21a8 8 0 0 1 13.292-6"/>
        <circle cx="10" cy="8" r="5"/>
        <path d="M19 16v6"/>
        <path d="M22 19h-6"/>
    </svg>
);

export default UserPlus;
